import { JSX } from "react";
import Skeleton from "react-loading-skeleton";

export const ProductSpecificationsBodySkeleton = (): JSX.Element => (
    <div>
        <Skeleton height="3rem" width="95%" borderRadius="0.8rem" />
        <Skeleton height="3rem" width="80%" borderRadius="0.8rem" />
    </div>
);
